module.exports = __webpack_public_path__ + "static/logo-063acecb2016898f8ff2811023c5565b.svg";